/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AuthService } from './services/AuthService';
import { AzureService } from './services/AzureService';
import { CliService } from './services/CliService';
import { DataAccessService } from './services/DataAccessService';
import { DataTransferService } from './services/DataTransferService';
import { HealthService } from './services/HealthService';
import { JobService } from './services/JobService';
import { OpenapiService } from './services/OpenapiService';
import { SealogService } from './services/SealogService';
import { StorageOpsService } from './services/StorageOpsService';
import { TileService } from './services/TileService';
import { UsersService } from './services/UsersService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class MakoAPIClient {

    public readonly auth: AuthService;
    public readonly azure: AzureService;
    public readonly cli: CliService;
    public readonly dataAccess: DataAccessService;
    public readonly dataTransfer: DataTransferService;
    public readonly health: HealthService;
    public readonly job: JobService;
    public readonly openapi: OpenapiService;
    public readonly sealog: SealogService;
    public readonly storageOps: StorageOpsService;
    public readonly tile: TileService;
    public readonly users: UsersService;

    public readonly request: BaseHttpRequest;

    constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.1.0',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });

        this.auth = new AuthService(this.request);
        this.azure = new AzureService(this.request);
        this.cli = new CliService(this.request);
        this.dataAccess = new DataAccessService(this.request);
        this.dataTransfer = new DataTransferService(this.request);
        this.health = new HealthService(this.request);
        this.job = new JobService(this.request);
        this.openapi = new OpenapiService(this.request);
        this.sealog = new SealogService(this.request);
        this.storageOps = new StorageOpsService(this.request);
        this.tile = new TileService(this.request);
        this.users = new UsersService(this.request);
    }
}

